import { Box } from '@razorpay/blade/components';
import React from 'react';

export const CardWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      gap="spacing.6"
      padding={['spacing.5', 'spacing.7']}
      borderWidth="thin"
      borderRadius="medium"
      borderColor="surface.border.gray.subtle">
      {children}
    </Box>
  );
};
